import Swiper from 'swiper';
import { Autoplay, Mousewheel, Navigation, Pagination, Scrollbar } from 'swiper/modules';

Swiper.use([Autoplay, Mousewheel, Navigation, Pagination, Scrollbar]);

jQuery(window).on('wc_prl_deployments_after_render', function () {

  // Isolate the global jQuery variable safely inside our execution scope
  const $ = jQuery;

  $('.wc-prl-recommendations').each(function () {
    const $el = $(this);

    // Check if Swiper has already been initialized on this element to prevent breaking layout duplicates
    if ($el.hasClass('swiper-initialized')) {
      return;
    }

    const $controls = $('<div class="swiper-controls"></div>');

    new Swiper($el.get(0), {
      createElements: true,
      wrapperClass: 'products',
      slideClass: 'product',
      slidesPerView: 'auto',
      spaceBetween: 24,
      navigation: {
        enabled: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      pagination: {
        enabled: true,
        clickable: true,
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          return `<span class="swiper-number">${current}</span> OF <span class="swiper-number">${total}</span>`;
        },
      },
      on: {
        init: function (swiper) {
          // Scope appends using jQuery to pull exactly this slider instance's children
          $controls.append($(swiper.navigation.prevEl), $(swiper.pagination.el), $(swiper.navigation.nextEl));

          const $wrapperEl = $el.find('.' + swiper.params.wrapperClass);
          $controls.insertBefore($wrapperEl);

          // FIX: Scoped context selections prevent global script duplication bugs
          $el.find('.swiper-button-prev').html('<span class="swiper-icon"></span>');
          $el.find('.swiper-button-next').html('<span class="swiper-icon"></span>');

          // Use a unique locator or .html() so it doesn't double-append if the event triggers twice
          if (!$el.find('.wc-prl-title span').length) {
            $el.find('.wc-prl-title').append('<span>Equipment similar to this product</span>');
          }
        },
        lock: function () {
          $controls.addClass('swiper-controls-lock');
        },
        unlock: function () {
          $controls.removeClass('swiper-controls-lock');
        },
      },
    });
  });
});
document.querySelectorAll('.wc-block-product-gallery-dialog').forEach(el => {
  const controls = document.createElement('div');
  new Swiper(el,{
    createElements:true,
    wrapperClass: 'wc-block-product-gallery-dialog__content',
    slideClass: 'product-img',
    slidesPerView: 1,
    direction:'horizontal',
    navigation: {
      enabled: true,
    },
    mousewheel:{
      forceToAxis: true,
    },
    on:{
      init: swiper => {
        controls.classList.add('swiper-controls');
        controls.append(swiper.navigation.prevEl, swiper.navigation.nextEl);
        swiper.el.insertBefore(controls, swiper.wrapperEl);
      },
      lock: swiper => {
        controls.classList.add('swiper-controls-lock');
      },
      unlock: swiper => {
        controls.classList.remove('swiper-controls-lock');
      },
    },
  });
  jQuery(document).ready(function ($) {
    $('.wc-block-product-gallery-dialog__content').wrap('<div class="wc-block-gallery-dialog__content-wrapper"></div>')
    $('.wc-block-product-gallery-dialog__content img').wrap('<div class="product-img"></div>');
  });
});
